import api from "../client";
import { ENDPOINTS } from "../endpoints";

export interface GenerateAPIKeyResponse {
  key: string;
  prefix: string;
  created_at: string;
}

export interface UserAPIKeyResponse {
  key?: string | null;
  key_prefix: string;
  created_at: string;
  last_used_at: string | null;
  request_count: number;
  expires_at: string | null;
}

export interface RevokeAPIKeyResponse {
  success: boolean;
  message: string;
}

export const apiKeyApi = {
  /**
   * Generate or regenerate user's API key
   */
  generateKey: async (): Promise<GenerateAPIKeyResponse> => {
    return api.post<GenerateAPIKeyResponse>(ENDPOINTS.API_KEY, {});
  },

  /**
   * Get user's API key metadata or full key
   */
  getKey: async (revealKey: boolean = false): Promise<UserAPIKeyResponse> => {
    return api.get<UserAPIKeyResponse>(ENDPOINTS.API_KEY, {
      params: { revealKey },
    });
  },

  /**
   * Revoke user's API key
   */
  revokeKey: async (): Promise<RevokeAPIKeyResponse> => {
    return api.delete<RevokeAPIKeyResponse>(ENDPOINTS.API_KEY);
  },
};

export default apiKeyApi;
